import { baseGatewayApiV1 } from '@verantos-dev/app-state-base';
import type { ListResponse, ObjectResponse } from '@verantos-dev/types-common';
import { DatasetListItem, DatasetDataCatalogDetails } from '@verantos-dev/types-datasets';

import { PROJECT_DATASET_RELEASES_BASE_PATH } from './constants';
import { formatDatasetReleases } from './utils';

export const datasetApiSlice = baseGatewayApiV1
  .enhanceEndpoints({
    addTagTypes: ['datatsets'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getNewDatasetReleases: builder.query<ListResponse<DatasetListItem>, undefined>({
        query: () => `/${PROJECT_DATASET_RELEASES_BASE_PATH}`,
        transformResponse: (response: ListResponse<DatasetListItem>) => {
          if (response?.data) {
            return {
              ...response,
              data: formatDatasetReleases(response.data),
            };
          }
          return response;
        },
      }),
      getNewDatasetReleaseById: builder.query<ObjectResponse<DatasetDataCatalogDetails>, string>({
        query: (releaseId: string) => `/${PROJECT_DATASET_RELEASES_BASE_PATH}/${releaseId}`,
      }),
    }),
  });

export const { useGetNewDatasetReleasesQuery, useGetNewDatasetReleaseByIdQuery } = datasetApiSlice;
